<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="保存模板"
        width="550px"
        append-to-body>
        <div class="tips pl20 mb20 font12px">
            <p><span class="text-bold">覆盖模板：</span>输入模板名称搜索，选择已有模板后保存会覆盖原模板。</p>
            <p><span class="text-bold">保存新模板：</span>输入一个不存在的模板名称，点击保存，即保存为新模板。</p>
        </div>
        <el-form ref="form" :model="formItem" :rules="rules" @submit.native.prevent label-width="0px" class="pl20 pr20">
            <el-form-item label="" prop="name" class="mr40 relative">
                <el-autocomplete
                    ref="searchInput"
                    :maxlength="35"
                    class="inline-input full-w"
                    v-model="formItem.name"
                    :fetch-suggestions="getNameList"
                    placeholder="请输入模板名称"
                    :trigger-on-focus="false"
                    @select="selectTemplate"
                    clearable
                ></el-autocomplete>
                <span class="word-limit">{{formItem.name.length}}/35</span>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/dataCenter.js';

    export default {
        name: "TemplateModal",
        props:{
            templateData:{
                type:Object,
                required: true,
            },
            platId:{
                type: [String,Number],
                required: true,
            },
        },
        data() {
            return {
                dialogVisible: false,
                submitLoading:false,
                nameList:[],
                formItem:{
                    id:'',
                    name:'',
                },
                rules:{
                    name:[
                        { required: true, message: '请输入模板名称', trigger: 'change' },
                        { min: 1, max: 35, message: '模板名称最多可输入35个字', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            handleClose() {
                this.resetForm();
                this.dialogVisible = false;
            },
            resetForm(){
                this.formItem.name = '';
                this.$refs['form'].resetFields();
            },
            showModal() {
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    // this.getUserList();
                    this.$refs.searchInput.focus();
                })
            },
            handleSubmit(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.submitLoading = true;
                        let reqData = {
                            id:this.formItem.id,
                            name:this.formItem.name,
                            plat_id:this.platId||'0',
                            condition_config:this.templateData.condition.map(item=>{
                                return {
                                    name:item.name,
                                    display_name:item.display_name,
                                    value:{
                                        contentValue:item.contentValue,
                                        dateValue:item.dateValue,
                                        selectValue:item.selectValue,
                                        selectLabel:item.selectLabel,
                                        timeValue:item.timeValue,
                                    },
                                    isExclude:item.isExclude,
                                }
                            }),
                            dimension_config:this.templateData.group.map(item=>{
                                let dimensionValue = item.dimensionValue||{};
                                return {
                                    name:item.name,
                                    display_name:item.display_name,
                                    sub_text:item.subText,
                                    order_by:dimensionValue.order_by,
                                    order_type:dimensionValue.order_type,
                                    show_num:dimensionValue.show_num,
                                    show_type:dimensionValue.show_type,
                                    start_date_dimension:dimensionValue.start_date_dimension,
                                    create_date_dimension:dimensionValue.create_date_dimension,
                                    yy_type_dimension:dimensionValue.yy_type_dimension,
                                    sum_type:dimensionValue.sum_type,
                                }
                            }),
                            field_config:this.templateData.field.map(item=>{
                                return {
                                    name:item.name,
                                    display_name:item.display_name,
                                }
                            }),
                            other_config:{
                                display_sum_dimension:this.templateData.display_sum_dimension,
                                dimension_default_sort:this.templateData.dimension_default_sort,
                                data_display_type:this.templateData.data_display_type,
                                cost_type:this.templateData.cost_type,
                                time_zone:this.templateData.time_zone,
                            }
                        };
                        return this.$emit('add',reqData);
                        this.submitLoading = true;
                        API.addTemplate(reqData).then(res=>{
                            this.submitLoading = false;
                            this.$message.success(res.info||'操作成功');
                            this.handleClose();

                        },err=>{
                            console.log('addTemplate err',err);
                            this.$message.error(err.info||'请求有误');
                            let errData = err.data||{};
                            let errInfo = errData.error || {};

                            let errCondition = errInfo.condition_config || [];
                            let errDimension = errInfo.dimension_config || [];
                            let errField = errInfo.field_config || [];
                            if (errCondition.length > 0 || errDimension.length > 0 || errField.length > 0) {
                                let conditionHtml = errCondition.length > 0 ? '<p class="pb6"><span class="text-bold">筛选条件：</span>' + errCondition.join('，') + '</p>' : '';
                                let dimensionHtml = errDimension.length > 0 ? '<p class="pb6"><span class="text-bold">维度分组：</span>' + errDimension.join('，') + '</p>' : '';
                                let fieldHtml = errField.length > 0 ? '<p class="pb6"><span class="text-bold">数据指标：</span>' + errField.join('，') + '</p>' : '';
                                let htmlStr = `<div class="tal" style="max-height: 300px;overflow: auto;">${conditionHtml}${dimensionHtml}${fieldHtml}</div>`;

                                this.$confirm(htmlStr, '以下已选条件无权限，保存失败', {
                                    showCancelButton: false,
                                    confirmButtonText: '我知道了',
                                    type: 'error',
                                    center: true,
                                    dangerouslyUseHTMLString: true,
                                    showClose: false,
                                    distinguishCancelAndClose: true,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false,
                                }).then(() => {
                                    // this.handleClose();
                                });
                            }

                            this.submitLoading = false;
                        });
                    } else {
                        return false;
                    }
                });
            },
            getNameList(queryString,cb){
                this.formItem.id = '';
                API.getTemplateList({
                    plat_id:this.platId||'0',
                    search: queryString,
                    all:1,
                }).then(res => {
                    let resData = res.data||{};
                    this.nameList = (resData||[]).map(item=>{
                        return {
                            id:item.id,
                            value:item.name,
                            name:item.name,
                        }
                    });
                    cb(this.nameList);
                }, (err) => {
                    console.log('getNameList error', err);
                    this.nameList = [];
                });
            },
            selectTemplate(item){
                this.formItem.id = item.id;
            }
        }
    }
</script>

<style lang="scss" scoped >
    .action-btn{
        width: 120px;
    }
    .word-limit{
        position: absolute;
        right: -45px;

    }
</style>
